import { render } from "./DrawerComponent.vue?vue&type=template&id=d7ed9610&scoped=true"
import script from "./DrawerComponent.vue?vue&type=script&lang=js"
export * from "./DrawerComponent.vue?vue&type=script&lang=js"

import "./DrawerComponent.vue?vue&type=style&index=0&id=d7ed9610&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Jude\\Desktop\\projects\\creditclan\\clan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7ed9610"]])

export default __exports__